define('views/cart-page-view',[
  'jquery',

  'modules/cart-actions',
  'modules/options-menu',

  'views/quick-cart',
  'views/process-options',

  'connections/cart-connection',

  'utils/view',
  'utils/form-validator',
  'utils/tooltip-init',
  'utils/pikaday-i18n',
  'utils/debounce',
  'pikaday',
  'settings'
], function (
  $,
  CartActions,
  OptionsMenu,
  QuickCart,
  ProcessOptions,
  CartConnection,
  View,
  FormValidator,
  tooltipInit,
  pikadayi18n,
  debounce,
  Pikaday,
  settings
) {
  var _this;
  var CartPageView = (function () {
    function CartPageView() {
      _this = this;
    }

    /**
     * If a specific cart (order, draft etc) is shown and not using the default cart
     *
     * @property cartId
     * @type {Int}
     */
    CartPageView.prototype.cartId = $('#cart').data('id');

    /**
     * Array used to check which articles are still loading.
     *
     * @property loadingSkus
     * @type {Array}
     */
    CartPageView.prototype.loadingSkus = [];

    /**
     * Array used to check which skus should be updated.
     *
     * @property skusToUpdate
     * @type {Array}
     */
    CartPageView.prototype.skusToUpdate = [];

    /**
     * Initializes the cart bindings.
     *
     * @method _init
     * @private
     */
    CartPageView.prototype._init = function () {
      var interval = this.initLoader();
      this.getCartPartialView(null, function () {
        clearInterval(interval);
        _this.checkMinDateForAllRows();
        _this.checkCampaignCode();
        _this.checkCartWarnings();
      });

      this.initDatePicker();

      this.initBindings();
      if (!this.cartId) {
        QuickCart.disablePopOver();
      }

      this.initCartActions();
      this.initProcessOptions();
    };

    CartPageView.prototype.initProcessOptions = function () {
      if (window.location.href.indexOf('?process=true') === -1) return;

      var PO = new ProcessOptions();
      PO.init($('#processOptions'));

      this.PO = PO;
    };

    CartPageView.prototype.initCartActions = function () {
      var $actions = $('[data-cart-actions]');

      // Cart Actions
      $actions.on('click', OptionsMenu.toggle);

      OptionsMenu.addBodyCloseListener('[data-cart-actions]');

      ca = new CartActions();
      $actions.on('click', '[data-cart-action="saveasdraft"]', function (e) {
        ca.saveAsDraft(e);
      });
      $actions.on('click', '[data-cart-action="converttooffer"]', function (e) {
        ca.convertToOffer(e);
      });
    };

    CartPageView.prototype.initBindings = function () {
      var cart = $('#cart');

      $('#sendCart .radio').change(function () {
        var selectedPaymentMethod;
        if ($('#credit-card').is(':checked')) {
          selectedPaymentMethod = $('#credit-card').val();
          $('#confirmOrderText').hide();
          $('#proceedToPaymentText').show();
        } else {
          selectedPaymentMethod = $('#invoice').val();
          $('#confirmOrderText').show();
          $('#proceedToPaymentText').hide();
          $('#deliveryCostNote').hide();
        }

        $('#placeOrderButton').hide();
        $('#loadingPaymentOption').show();
        CartConnection.getLargeCart('', this.cartId, selectedPaymentMethod)
          .then(function (result) {
            $('#largecarttest').html(result);
          })
          .then(function () {
            $('#loadingPaymentOption').hide();
            $('#placeOrderButton').show();

            if ($('#credit-card').is(':checked')) {
              $('#deliveryCostNote').show();
            } else {
              $('#deliveryCostNote').hide();
            }
          });
      });

      // Cart partial view
      cart.on('click', '.cart-product__item__config-comment', function () {
        _this.toggleCommentInput($(this).closest('.cart-product__item'));
      });
      cart.on('blur', '.comment', function () {
        _this.toggleCommentInput($(this).closest('.cart-product__item'));
      });
      cart.on('click', '.cart-product__delivery-date', this.toggleDatePicker);
      cart.on('click', '.cart__delivery-date', this.toggleDatePickerForAllRows);
      cart.on('click', '.item-remove', this.removeItem);
      cart.on('click', '.product-remove', this.removeProduct);
      cart.on('click', '.campaigncode-add', this.setCampaignCode);
      cart.on('click', '.campaigncode-remove', this.removeCampaignCode);

      cart.on('change', '.quantity', debounce(this.updateQuantity, 500));
      cart.on('change', '.comment', this.updateComment);

      // Form
      this.initForm();
      $('input[name="SelectedShippingAddress"]').on('change', this.toggleNewAddress);
      $('#ordertype').on('change', this.toggleOrderTransportTypeDescription);
      $('#transporttype').on('change', this.toggleOrderTransportTypeDescription);
      $('#termsandconditions').on('change', this.toggleSubmitBtn);

      $('#sendCart').on('submit', this.validateInput);
      this.toggleOrderTransportTypeDescription();
    };

    CartPageView.prototype.initForm = function () {
      _this.$form = $('#sendCart');
      var formValidator = new FormValidator(_this.$form);

      formValidator.removeInputErrorMsgOn('keypress');
      _this.$form.on('change', this.toggleSubmitBtn);

      _this.$form.on('change', debounce(this.updateOrderHeader, 500));
      formValidator.validateInputOn('change');
      this.formValidator = formValidator;
    };

    /**
     * Init tooltips for cart partial view. Called after new view is returned.
     */
    CartPageView.prototype.initTooltips = function () {
      // Prevent binding on touch devices.
      if (!Modernizr.touch) tooltipInit($('#cart'));
    };

    /**
     * Init datepicker with default options.
     */
    CartPageView.prototype.initDatePicker = function () {
      this.picker = new Pikaday({
        disableWeekends: true,
        firstDay: 1,
        i18n: pikadayi18n,
        onSelect: _this.updateDate
      });
    };

    /**
     * Displays the initial loader texts. Updates every few seconds with the next text until the html is loaded.
     */
    CartPageView.prototype.initLoader = function () {
      var loaderText = $('.cart-loader__text');

      index = 0;
      loaderText.eq(index).fadeIn();
      return setInterval(function () {
        loaderText.eq(index).fadeOut(function () {
          index += 1;
          loaderText.eq(index).fadeIn();
          if (index === 4) clearInterval(_this.loaderInterval);
        });
      }, 3000);
    };

    CartPageView.prototype.toggleNewAddress = function () {
      var newAddress = $('#new-address'),
        shippingAddressWrapper = $('.shipping-details__address-picker');

      if ($('#shipping-address-new').is(':checked')) {
        $('.shipping-details__address-picker__info').addClass('visible');
        newAddress.find(':input').removeAttr('disabled');
        newAddress.slideDown();
      } else {
        $('.shipping-details__address-picker__info').removeClass('visible');
        newAddress.find(':input').attr('disabled', 'disabled');
        newAddress.slideUp();
      }

      shippingAddressWrapper.find('.selected').removeClass('selected');
      $(this).closest('li').addClass('selected');
    };

    CartPageView.prototype.toggleCommentInput = function (lineEl) {
      var commentRow = lineEl.find('.cart-product__comment');
      if (commentRow.is(':animated')) return;
      commentRow.slideToggle(200, function () {
        if (commentRow.is(':visible')) commentRow.find('input').focus();
      });
    };

    CartPageView.prototype.checkMinDateForAllRows = function () {
      var lines = $('.cart-product__delivery-date, .cart-product__delivery-date--unknown');
      var minDates = [];

      $.each(lines, function (i) {
        var minDate = $(this).closest('[data-min-date]').data('min-date');
        minDates.push(minDate);
      });

      var cartMinDate = Math.max.apply(null, minDates);
      if (cartMinDate > 0) {
        $('.cart__column-container').attr('data-min-date', cartMinDate);
      }
      else {
        $('.cart__column-container').hide();
      }
    };

    CartPageView.prototype.toggleDatePickerForAllRows = function (e) {
      if ($(_this.picker.el).is(':visible')) return _this.picker.hide();
      e.stopPropagation();

      var lines = $('.cart-product__delivery-date');
      var minDateString = $(this).closest('.cart__column-container').data('min-date');
      var pikadayContainer = $('.cart__delivery-date-container').find('.cart__pikaday-container');

      _this.picker.setMinDate(new Date(+minDateString));
      pikadayContainer.append(_this.picker.el);
      _this.picker.show();

      $.each(lines, function (i) {
        var sku = $(this).closest('.cart-product__item').data('sku');
        _this.skusToUpdate.push({
          code: sku
        });
      });

      // Close picker on click outside.
      $(window).one('click.pikaday', function (e) {
        if (!$.contains(_this.picker.el, e.target)) _this.picker.hide();
        _this.skusToUpdate.length = 0;
      });
    };

    /**
     * Opens datepicker at the right location and sets properties to the corresponding sku
     * values (min-date).
     */
    CartPageView.prototype.toggleDatePicker = function (e) {
      if ($(_this.picker.el).is(':visible')) return _this.picker.hide();
      e.stopPropagation();

      var line = $(this).closest('.cart-product__item');
      var sku = line.data('sku');
      var minDateString = $(this).closest('.cart-product__item__column-container').data('min-date');
      var pikadayContainer = line.find('.cart-product__pikaday-container');

      _this.picker.setMinDate(new Date(+minDateString));
      pikadayContainer.append(_this.picker.el);
      _this.picker.show();

      _this.skusToUpdate.push({
        code: sku
      });

      // Close picker on click outside.
      $(window).one('click.pikaday', function (e) {
        if (!$.contains(_this.picker.el, e.target)) _this.picker.hide();
        _this.skusToUpdate.length = 0;
      });
    };

    /**
     * Updates a lineitem comment, then updates Cart partial view.
     */
    CartPageView.prototype.updateComment = function () {
      var line = $(this).closest('.cart-product__item');
      var sku = line.data('sku');
      var commentText = $(this).val();

      _this.showLoader(sku);
      CartConnection.changeComment(sku, commentText)
        .then(function () {
          var classToRemove = commentText.length ? 'icon-comment' : 'icon-commented';
          var classToAdd = commentText.length ? 'icon-commented' : 'icon-comment';
          line.find('.cart-product__item__config-comment').removeClass(classToRemove).addClass(classToAdd);
        })
        .always(function () {
          _this.hideLoader(sku, line);
        });
    };

    /**
     * Updates a lineitem date, then updates Cart partial view.
     *
     * @param {String} sku - The sku to update.
     * @param {String} date - A date string from pikaday datepicker.
     */
    CartPageView.prototype.updateDate = function (date) {
      $(window).off('click.pikaday'); // remove outside close eventlistener
      _this.picker.hide();

      var unixTimeStamp = date.getTime();
      var skuList = _this.skusToUpdate;

      $.each(skuList, function (i, sku) {
        _this.showLoader(sku.code);
      });

      CartConnection.changeDate(skuList, unixTimeStamp, _this.cartId)
        .then(function (res) {
          $.each(skuList, function (i, sku) {
            var line = $('.cart-product__item[data-sku="' + sku.code + '"]');
            var dateField = line.find('.cart-product__delivery-date');
            dateField.text(res);
            if (!dateField.hasClass('cart-product__delivery-date--selected'))
              dateField.addClass('cart-product__delivery-date--selected');
          });
          if (_this.PO) _this.PO.getProcessOptionsPartialView();
        })
        .always(function () {
          $.each(skuList, function (i, sku) {
            var line = $('.cart-product__item[data-sku="' + sku.code + '"]');
            _this.hideLoader(sku.code, line);
          });

          _this.skusToUpdate.length = 0;
        });
    };

    /**
     * Deletes a product, then updates Cart partial view.
     *
     * @method removeProduct
     * @param e
     */
    CartPageView.prototype.removeProduct = function () {
      var pid = $(this).closest('.cart-product').data('product-id');

      $(this).hide();
      $(this).next('.product-loader').addClass('product-loader--visible');

      CartConnection.deleteProduct(pid)
        .then(function (totalQty) {
          QuickCart.printTotalQuantity(totalQty);
          if (_this.PO) _this.PO.getProcessOptionsPartialView();
        })
        .always(function () {
          _this.getCartPartialView(pid);
        });
    };

    CartPageView.prototype.removeItem = function () {
      var sku = $(this).closest('.cart-product__item').data('sku');

      _this.changeQuantity(sku, 0);
    };

    CartPageView.prototype.updateQuantity = function () {
      var sku = $(this).closest('.cart-product__item').data('sku');
      var boxItems = $(this).data('validateBox');
      var val = $(this).val();
      var qty = boxItems ? boxItems * val : val;
      _this.changeQuantity(sku, qty);
    };

    CartPageView.prototype.updateOrderHeader = function () {
      _this.sendOrderHeader(_this.$form.serialize());
    };

    /**
     * Updates a lineitem quantity, then updates Cart partial view.
     *
     * @method updateLineItem
     */
    CartPageView.prototype.changeQuantity = function (sku, qty) {
      _this.showLoader(sku);

      CartConnection.changeQuantity(sku, qty, _this.cartId)
        .then(function (totalQty) {
          QuickCart.printTotalQuantity(totalQty);
          if (_this.PO) _this.PO.getProcessOptionsPartialView();
        })
        .always(function () {
          _this.getCartPartialView(sku);
        });
    };

    CartPageView.prototype.sendOrderHeader = function (header) {
      CartConnection.updateOrderHeader(header);
    };

    /**
     * Check if any cart warnings are present and print them in the end of the cart form.
     * ! This function manipulates the Shipping Details form which is in a different view.
     *
     * @method checkCartWarnings
     */
    CartPageView.prototype.checkCartWarnings = function () {
      var $cartWarnings = $('#cart').find('.cart-warning'),
        $cartWarningContainer = $('#cart-warnings');

      $cartWarningContainer.empty();
      if ($cartWarnings.length && $cartWarningContainer.length) {
        $cartWarningContainer.append($cartWarnings.clone());
      }
    };

    /**
     * Check if campaign code is applied. If so hide order type option in Shipping Details form.
     *
     * @method checkCampaignCode
     */
    CartPageView.prototype.checkCampaignCode = function () {
      $campaignCodeApplied = $('.cart-campaign__code--applied');

      if ($campaignCodeApplied.length) {
        _this.hideOrderTypeOption();
      }
    };

    /**
     * Sets a campaign code, then updates Cart partial view.
     *
     * @method setCampaignCode
     */
    CartPageView.prototype.setCampaignCode = function () {
      var code = $('.campaigncode-input').val();

      $(this).find('.loader').addClass('loader--visible');

      CartConnection.setCampaignCode(code).then(function () {
        _this.getCartPartialView(null, function () {
          _this.hideOrderTypeOption();
        });
      });
    };

    /**
     * Removes campaign code, then updates Cart partial view.
     * ? Order type select is overriden in backend if a campaign code is applied, so we just show the Select element again if the campaign code is removed
     *
     * @method removeCampaignCode
     */
    CartPageView.prototype.removeCampaignCode = function () {
      $(this).find('.loader').addClass('loader--visible');
      $(this).removeClass('icon-cancel');

      CartConnection.removeCampaignCode().then(function () {
        _this.getCartPartialView(null, function () {
          _this.showOrderTypeOption();
        });
      });
    };

    /**
     * Shows order type option in Shipping Details form
     * ! This function manipulates the Shipping Details form which is in a different view.
     *
     * @method showOrderTypeOption
     */
    CartPageView.prototype.showOrderTypeOption = function () {
      var $orderTypeSelect = $('.ordertype-select');

      if ($orderTypeSelect.length) {
        $orderTypeSelect.show();
      }
    };

    /**
     * Hides order type option in Shipping Details form
     * ? Order type select is overriden in backend if a campaign code is applied, so we just hide the Select element if a campaign code is applied
     * ! This function manipulates the Shipping Details form which is in a different view.
     *
     * @method hideOrderTypeOption
     */
    CartPageView.prototype.hideOrderTypeOption = function () {
      var $orderTypeSelect = $('.ordertype-select');
      var $campaignCodeApplied = $('.cart-campaign__code--applied');

      if ($campaignCodeApplied.length && $orderTypeSelect.length) {
        $orderTypeSelect.hide();
      }
    };

    /**
     * Get Cart partial view from backend. - If told, it will update lineitem spinners and update
     * quantity bubble in quick cart when done.
     *
     * @param  {String} [sku]      - If provided it will hide the loader for the line item with this sku and reapply
     *                               all other loaders.
     * @param {function}[cb]       - Callback
     *
     * @method getCartPartialView
     */
    CartPageView.prototype.getCartPartialView = function (sku, cb) {
      CartConnection.getLargeCart(sku, this.cartId)
        .then(function (res) {
          $('#cart').html(res);
          $('#cart').trigger('domChanged');

          _this.initTooltips();
          _this.checkCartWarnings();
        })
        .always(function () {
          if (sku) _this.hideLoader(sku);
          _this.showLoaders();
          if (cb) cb();
        });
    };

    /**
     * Shows overlay loader on articles still loading.
     *
     * @param {String} [sku] - A sku that should be added to the list of lines that should display a loader
     *
     * @method showLoaders
     */
    CartPageView.prototype.showLoaders = function () {
      $.each(_this.loadingSkus, function (i, sku) {
        var line = $('.cart-product__item[data-sku="' + sku + '"]');
        var loader = line.find('.item-loader');
        if (!loader.hasClass('item-loader--visible')) {
          loader.addClass('item-loader--visible');
          line.find('.item-remove').hide();
        }
      });

      _this.toggleSubmitBtn();
    };

    /**
     * Adds sku to loader list, then applies all loaders.
     * @param  {String} sku - Id that is used to find the right line to show loader for.
     */
    CartPageView.prototype.showLoader = function (sku) {
      _this.loadingSkus.push(sku);
      _this.showLoaders();
    };

    /**
     * Hides loader spinner for the given sku.
     * @param {String} sku           - Id that is used to find the right line to show loader for. Here it is
     *                                 removed from the list so calls to showLoader() is not showing it.
     * @param {jQueryElement} [line] - If provided it means the view will probably not be entirely reloaded so
     *                                 we reset loader and remove-button manually.
     */
    CartPageView.prototype.hideLoader = function (sku, line) {
      var index = _this.loadingSkus.indexOf(sku);

      _this.loadingSkus.splice(index, 1);
      _this.toggleSubmitBtn();

      if (line) {
        line.find('.item-loader').removeClass('item-loader--visible');
        line.find('.item-remove').show();
      }
    };

    CartPageView.prototype.showOverlayLoader = function () {
      $('.overlay-loader').addClass('overlay-loader--visible');
    };

    /**
     * Bind order type select input to toggle description tags.
     */
    CartPageView.prototype.toggleOrderTransportTypeDescription = function () {
      var $orderDescriptionWrapper = $('.shipping-details__deliver__description');
      var $transportDescriptionWrapper = $('.shipping-details__transport__description');
      var $orderSelect = $("#ordertype");
      var $transportSelect = $("#transporttype");

      $transportDescriptionWrapper.find('.active').removeClass('active');
      $orderDescriptionWrapper.find('.active').removeClass('active');
      var $selectedOrderDescription = $orderDescriptionWrapper.find('[data-deliver="' + $orderSelect.val() + '"]');
      var $selectedTransportDescription = $transportDescriptionWrapper.find('[data-deliver="' + $transportSelect.val() + '"]');
      $selectedOrderDescription.addClass('active');
      $selectedTransportDescription.addClass('active');

      var hideShipping = $selectedOrderDescription.data("hidedelivery") === "True" || $selectedTransportDescription.data("hidedelivery") === "True";

      var shippingDetails = $("#shipping-details");
      if (hideShipping) {
        var newAdressIsSelected = $('#shipping-address-new').is(':checked');
        if (newAdressIsSelected) $('[id^=SelectedShippingAddress_]').first().click();
        shippingDetails.hide();
      }
      else {
        shippingDetails.show();
      }
    };

    CartPageView.prototype.toggleSubmitBtn = function () {
      var placeOrderBtn = $('#placeOrderButton');
      var isTermsAccepted = $('#termsandconditions').is(':checked');
      var isSkusLoading = _this.loadingSkus.length > 0;
      var isCartEmpty = $('.cart-product__item').length < 1;
      var minOrderAmountInvalid = $('#minOrderAmountRestriction').length > 0;
      var cartHasInvalidItems = $('.cart-product__item .cart-product__item__description--invalid').length > 0;
      var isAllowedToPlaceOrder = true;
      if ($('#credit-card').is(':checked')) {
        if (document.getElementById('orderTotalIncVat').value <= 0)
          isAllowedToPlaceOrder = false;
      }

      placeOrderBtn.prop(
        'disabled',
        !isTermsAccepted || isSkusLoading || isCartEmpty || cartHasInvalidItems || minOrderAmountInvalid || !isAllowedToPlaceOrder
      );

      if (isSkusLoading) $('#confirm-button-loader').empty().append('<div class="loader button-loader"></div>');
      else $('#confirm-button-loader').empty();

      placeOrderBtn.removeClass('button--error');
    };

    CartPageView.prototype.validateInput = function (e, blockOverlayLoader) {
      var isValidForm = _this.formValidator.validateForm();
      var isValidPO = true;
      if (_this.PO) isValidPO = _this.PO.validateProcessOptions();

      if (!isValidForm || !isValidPO) {
        $('#placeOrderButton').addClass('button--error');
        return false;
      } else if (!blockOverlayLoader) {
        _this.showOverlayLoader();
        $('#placeOrderButton').prop('disabled', 'disabled');
      }
      return true;
    };

    return CartPageView;
  })();

  return View('CartPageView', function () {
    var cv = new CartPageView();
    cv._init();
  });
});
